// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__10yZx","newExpiryDate":"styles_newExpiryDate__1An7A","footer":"styles_footer__12uVj"};